import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import FocusLock from 'react-focus-lock';
import keyboardKey from 'keyboard-key';
import Icon from '../../../components/Icon';
import { USE_PLACEID_FOR_GEOCODE_API } from '../../Authorization/constants';

import '../styles.css';

const SuggestionList = ({
  suggestions,
  onSelectionChange,
  focusLock,
  onClosePopup,
  enabledFeatures,
}) => {
  useEffect(() => {
    if (focusLock) return;
    const element = document.querySelector('ul#suggestion-list li:nth-child(1) > button');
    if (element) {
      element.focus();
    }
  }, [focusLock]);

  const onKeyDownRow = (event, index, suggestion) => {
    const code = keyboardKey.getCode(event);
    switch (code) {
      case keyboardKey.ArrowUp: {
        if (index === 0) {
          document.querySelector(`ul#suggestion-list li:nth-child(${suggestions.length}) > button`).focus();
          setTimeout(() => {
            document.querySelector(`ul#suggestion-list li:nth-child(${suggestions.length}) > button`).scrollIntoView();
          }, 50);
          return;
        }
        document.querySelector(`ul#suggestion-list li:nth-child(${index}) > button`).focus();
        break;
      }

      case keyboardKey.ArrowDown: {
        if (index === suggestions.length - 1) {
          document.querySelector('ul#suggestion-list li:nth-child(1) > button').focus();
          setTimeout(() => {
            document.querySelector('ul#suggestion-list li:nth-child(1) > button').scrollIntoView();
          }, 50);
          return;
        }
        document.querySelector(`ul#suggestion-list li:nth-child(${index + 2}) > button`).focus();
        break;
      }

      case keyboardKey.Enter: {
        onSelectionChange(suggestion);
        break;
      }

      default: {
        onClosePopup();
        break;
      }
    }
  };

  const renderSuggestion = (suggestion, index) => (
    <li role="option" aria-selected key={`${enabledFeatures.includes(USE_PLACEID_FOR_GEOCODE_API) ? suggestion.placeId : suggestion}`}>
      <button
        type="button"
        styleName="title-button suggestion-button"
        onClick={() => onSelectionChange(suggestion)}
        onKeyDown={(event) => onKeyDownRow(event, index, suggestion)}
      >
        <Icon color="grey" size="large" name="map marker alternate" />
        <span className="suggestion-title">{`${enabledFeatures.includes(USE_PLACEID_FOR_GEOCODE_API) ? suggestion.street : suggestion}`}</span>
      </button>
    </li>
  );

  return (
    <FocusLock returnFocus autoFocus disabled={focusLock}>
      <div id="suggestion-popup" styleName="suggestion-popup">
        <ul data-cy="location-suggestion-list" id="suggestion-list" styleName="suggestion-list">
          {suggestions.map(renderSuggestion)}
        </ul>
      </div>
    </FocusLock>
  );
};

SuggestionList.propTypes = {
  suggestions: PropTypes.array.isRequired,
  onSelectionChange: PropTypes.func.isRequired,
  focusLock: PropTypes.bool,
  onClosePopup: PropTypes.func.isRequired,
  enabledFeatures: PropTypes.array.isRequired,
};

export default SuggestionList;
